import { createAsyncThunk } from '@reduxjs/toolkit';
import { _redoScan } from '@custom/Utils/constants/apiUrls';

interface RedoScanArgs {
  patientID: any;
  payload: {
    status: string;
  };
}

const redoScan = createAsyncThunk(
  'redoScan',
  async ({ patientID, payload }: RedoScanArgs, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const url = `${_redoScan.patch}/${patientID}`;
      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        throw new Error('Failed to fetch price data');
      }
      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export default redoScan;
